import {
  store
} from "../store/index"

// import {
//   getWiseContract,
//   getWeb3
// } from "../utils/contract_mainnet_staking";
// } from "../utils/contract_testnet_staking";

import config from "./config.json";

import axios from "axios";

// if(process.env.ENVIRONMENT === "production") const apiUrl = "https://www.wiseinfo.io/api";
// if(process.env.ENVIRONMENT === "development") const apiUrl = "https://www.wiseinfo.io/api_alpha";
export const apiUrl = process.env.VUE_APP_ENVIRONMENT === "development" ? "https://www.wiseinfo.io/api_alpha" : "https://www.wiseinfo.io/api";
// const apiUrl = "https://www.wiseinfo.io/api_alpha";
// export const apiUrl = "http://localhost:3001";

// var wiseStakingContract = null;
// var web3 = null;
var infuraWiseStakingContract = null;
var infuraWeb3 = null;
var wiseStakingContract = null;
var web3 = null;

import {
  getInfuraWiseContract as getInfuraWiseContractMainnet,
  getInfuraWeb3 as getInfuraWeb3Mainnet
} from '../utils/contract_mainnet_staking';
import {
  getInfuraWiseContract as getInfuraWiseContractTestnet,
  getInfuraWeb3 as getInfuraWeb3Testnet
} from '../utils/contract_testnet_staking';

async function createContract() {
  let {
    getWiseContract,
    getWeb3
  } = process.env.VUE_APP_ENVIRONMENT === "development" ?
    await import('../utils/contract_testnet_staking') :
    await import('../utils/contract_mainnet_staking')
  if (wiseStakingContract === null) {
    wiseStakingContract = await getWiseContract();
  }
  if (web3 === null) {
    web3 = await getWeb3();
  }
}

async function createInfuraContract() {
  if (process.env.VUE_APP_ENVIRONMENT === "development") {
    if (infuraWiseStakingContract === null) {
      infuraWiseStakingContract = await getInfuraWiseContractTestnet();
    }
    if (infuraWeb3 === null) {
      infuraWeb3 = await getInfuraWeb3Testnet();
    }
  } else {
    if (infuraWiseStakingContract === null) {
      infuraWiseStakingContract = await getInfuraWiseContractMainnet();
    }
    if (infuraWeb3 === null) {
      infuraWeb3 = await getInfuraWeb3Mainnet();
    }
  }
}

// async function createInfuraContract() {
//   let {
//     getInfuraWiseContract,
//     getInfuraWeb3
//   } = process.env.VUE_APP_ENVIRONMENT === "development" ?
//     await import('../utils/contract_testnet_staking') :
//     await import('../utils/contract_mainnet_staking')
//   if (infuraWiseStakingContract === null) {
//     infuraWiseStakingContract = await getInfuraWiseContract();
//   }
//   if (infuraWeb3 === null) {
//     infuraWeb3 = await getInfuraWeb3();
//   }
// }

async function createInfuraWeb() {
  if (process.env.VUE_APP_ENVIRONMENT === "development") {
    if (infuraWeb3 === null) {
      infuraWeb3 = getInfuraWeb3Testnet();
    }
  } else {
    if (infuraWeb3 === null) {
      infuraWeb3 = await getInfuraWeb3Mainnet();
    }
  }
}



export async function startDataPolling() {
  // await createContract();
  await createInfuraContract();
  updateAllData();
  startIntervals();
}

function startIntervals() {
  setInterval(getAndStoreCurrentWiseDay, config.pollingInterval1m);
  setInterval(getETHPrice, config.pollingInterval1m);
  // setInterval(getAndStoreTotalInvestedETH, config.pollingInterval5m);
  // setInterval(getAndStoreTopReferrers, config.pollingInterval10m);
  // setInterval(getAndStoreMultipleInvestmentsOnAllDays, config.pollingInterval5m);
  setInterval(updateLastUpdateSeconds, config.pollingInterval1s);
  setInterval(getAndStoreCurrentEthereumBlock, config.pollingInterval5m);
  // setInterval(getAndStoreSupplyOnAllDays, config.pollingInterval5m);
  setInterval(getAndStoreTotalSupply, config.pollingInterval5m);
  setInterval(getAndStoreGlobals, config.pollingInterval5m);
  setInterval(getAndStoreTotalStakedInsurance, config.pollingInterval5m);
  setInterval(getAndStoreUniswapBalance, config.pollingInterval5m);
  setInterval(getAndStoreHolders, config.pollingInterval5m);
  setInterval(getPriceAndLiquidityAndRank, config.pollingInterval30s);
  // setInterval(getTotalUniswapTradingVolume, config.pollingInterval30s);
  setInterval(getAndStoreAllPenalties, config.pollingInterval30s);
  setInterval(getAndStoreStakeStats, config.pollingInterval1m);
  setInterval(getCoingeckoMarketData, config.pollingInterval5m);

}

export async function updateAllData() {

  getAndStoreCurrentWiseDay();
  getETHPrice();
  // getAndStoreMultipleInvestmentsOnAllDays();
  // getAndStoreTotalInvestedETH();
  // getAndStoreTopReferrers();
  getAndStoreCurrentEthereumBlock();
  // getAndStoreSupplyOnAllDays();
  getAndStoreTotalSupply();
  getAndStoreGlobals();
  getAndStoreTotalStakedInsurance();
  getAndStoreUniswapBalance();
  getAndStoreHolders();
  getPriceAndLiquidityAndRank();
  // getTotalUniswapTradingVolume();
  getAndStoreAllPenalties();
  getAndStoreStakeStats();
  getCoingeckoMarketData();
}

function getCoingeckoMarketData() {
  // const apiurl = "https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6&vs_currencies=usd%2Cbtc%2Ceth&include_market_cap=true&include_24hr_vol=true&include_24hr_change=true&include_last_updated_at=true"
  // const contractAddress = "0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6";

  const apiurl2 = "https://api.coingecko.com/api/v3/coins/wise-token11?tickers=false&market_data=true&community_data=false&developer_data=false&sparkline=false"

  let coingeckoStats = {
    price_usd: -1,
    price_eth: -1,
    change_1h_usd: -1,
    change_1h_eth: -1,
    change_24h_usd: -1,
    change_24h_eth: -1,
    change_7d_usd: -1,
    change_7d_eth: -1,
    change_14d_usd: -1,
    change_14d_eth: -1,
    vol_usd: -1,
    vol_eth: -1,
  }
  axios.get(apiurl2)
    .then((resp) => {
      let result = resp.data;
      coingeckoStats.price_usd = result.market_data.current_price.usd,
        coingeckoStats.price_eth = result.market_data.current_price.eth,
        coingeckoStats.change_1h_usd = result.market_data.price_change_percentage_1h_in_currency.usd,
        coingeckoStats.change_1h_eth = result.market_data.price_change_percentage_1h_in_currency.eth,
        coingeckoStats.change_24h_usd = result.market_data.price_change_percentage_24h_in_currency.usd,
        coingeckoStats.change_24h_eth = result.market_data.price_change_percentage_24h_in_currency.eth,
        coingeckoStats.change_7d_usd = result.market_data.price_change_percentage_7d_in_currency.usd,
        coingeckoStats.change_7d_eth = result.market_data.price_change_percentage_7d_in_currency.eth,
        coingeckoStats.change_14d_usd = result.market_data.price_change_percentage_14d_in_currency.usd,
        coingeckoStats.change_14d_eth = result.market_data.price_change_percentage_14d_in_currency.eth,
        coingeckoStats.vol_usd = result.market_data.total_volume.usd,
        coingeckoStats.vol_eth = result.market_data.total_volume.eth,
        store.commit("SET_COINGECKO_STATS", coingeckoStats);
    })
}

async function getAndStoreCurrentWiseDay() {
  let currentWiseDay = await getCurrentWiseDayFromDatabase();
  // let currentWiseDay = await getCurrentWiseDayFromContract();
  currentWiseDay = parseInt(currentWiseDay) + 0;
  store.commit("SET_CURRENT_WISE_DAY", parseInt(currentWiseDay));
  updateLastUpdate();
}

async function getCurrentWiseDayFromDatabase() {
  let currentWiseDay = await axiosget("currentWiseDay");
  return parseInt(currentWiseDay);
}

// async function getCurrentWiseDayFromContract() {
//   let currentWiseDay = -1;
//   try {
//     currentWiseDay = await wiseStakingContract.methods.currentWiseDay().call();
//   } catch(ex) {
//     console.log(ex.message)
//   }
//   return currentWiseDay;
// }

async function getAndStoreTotalSupply() {
  let totalSupply = await getTotalSupplyFromDatabase();
  store.commit("SET_TOTAL_SUPPLY", parseFloat(totalSupply));
  updateLastUpdate();
}
async function getTotalSupplyFromDatabase() {
  let totalSupply = await axiosget("totalSupply_staking");
  return parseFloat(totalSupply);
  //TODO use correct value
  // let totalSupply = -1;
  // try {
  //   totalSupply = await wiseStakingContract.methods.totalSupply().call();
  //   totalSupply = totalSupply / 10 ** 18
  // } catch(ex) {
  //   console.log(ex.message)
  // }
  // return totalSupply;
}
async function getAndStoreGlobals() {
  let totalStaked = await getTotalStakedFromDatabase();
  let sharePrice = await getSharePriceFromDatabase();
  let totalShares = await getTotalSharesFromDatabase();
  let referralShares = await getReferralSharesFromDatabase();
  store.commit("SET_TOTAL_STAKED", parseFloat(totalStaked));
  store.commit("SET_SHARE_PRICE", parseFloat(sharePrice));
  store.commit("SET_TOTAL_SHARES", parseFloat(totalShares));
  store.commit("SET_REFERRAL_SHARES", parseFloat(referralShares));
  updateLastUpdate();
}
async function getAndStoreTotalStakedInsurance() {
  let totalStakedInsurance = await getTotalStakedInsuranceFromDatabase();
  store.commit("SET_TOTAL_STAKED_INSURANCE", parseFloat(totalStakedInsurance));
  updateLastUpdate();
}
async function getTotalStakedInsuranceFromDatabase() {
  let totalStakedInsurance = await axiosget("totalStakedInsurance");
  return parseFloat(totalStakedInsurance);
}

async function getTotalStakedFromDatabase() {
  let totalStaked = await axiosget("totalStaked_staking");
  return parseFloat(totalStaked);
  //TODO use correct value
  // let totalStaked = -1;
  // let globals = null;
  // try {
  //   globals = await wiseStakingContract.methods.globals().call();
  //   totalStaked = globals['totalStaked'] / 10 ** 18;
  // } catch(ex) {
  //   console.log(ex.message)
  // }
  // return totalStaked;
}
async function getSharePriceFromDatabase() {
  let sharePrice = await axiosget("sharePrice_staking");
  return parseFloat(sharePrice);
}
async function getTotalSharesFromDatabase() {
  let totalShares = await axiosget("totalShares_staking");
  return parseFloat(totalShares);
}
async function getReferralSharesFromDatabase() {
  let referralShares = await axiosget("referralShares_staking");
  return parseFloat(referralShares);
}
async function getAndStoreUniswapBalance() {
  let uniswapBalance = await getUniswapBalanceFromDatabase();
  store.commit("SET_UNISWAP_BALANCE", parseFloat(uniswapBalance));
  updateLastUpdate();
}
async function getUniswapBalanceFromDatabase() {
  let uniswapBalance = await axiosget("uniswapBalance_staking");
  return parseFloat(uniswapBalance);
  //TODO use correct value
  // let uniswapBalance = -1;
  // try {
  //   let uniswapAddress = await wiseStakingContract.methods.UNISWAP_PAIR().call();
  //   uniswapBalance = await wiseStakingContract.methods.balanceOf(uniswapAddress).call() / 10 ** 18;
  // } catch(ex) {
  //   console.log(ex.message)
  // }
  // return uniswapBalance;
}

async function getAndStoreHolders() {
  let holders = await getHoldersFromDatabase();
  store.commit("SET_HOLDERS", parseFloat(holders));
  updateLastUpdate();
}

async function getHoldersFromDatabase() {
  let holders = await axiosget("holders");
  return parseFloat(holders);
}

// async function getAndStoreTotalInvestedETH() {
//   let totalInvestedETH = await getTotalInvestedETHFromDatabase();
//   store.commit("SET_TOTAL_INVESTED_ETH", parseFloat(totalInvestedETH));
//   updateLastUpdate();
// }

// async function getAndStoreTopReferrers() {
//   let topReferrers = await getTopReferrersFromDatabase();
//   store.commit("SET_TOP_REFERRERS", topReferrers);
//   updateLastUpdate();
// }

// async function getAndStoreSupplyOnAllDays() {
//   let supplyOnAllDays = await getSupplyOnAllDaysFromDatabase();
//   supplyOnAllDays = JSON.parse(supplyOnAllDays);
//   supplyOnAllDays.shift(); //remove first element;
//   supplyOnAllDays = supplyOnAllDays.map(supply => supply * 1);
//
//   store.commit("SET_SUPPLY_ON_ALL_DAYS", supplyOnAllDays);
//   updateLastUpdate();
// }

// async function getSupplyOnAllDaysFromDatabase() {
//   let supplyOnAllDays = await axiosget("supplyOnAllDays");
//   return supplyOnAllDays;
// }

async function getAndStoreCurrentEthereumBlock() {
  var date = new Date();
  var timestamp = parseInt(date.getTime() / 1000);
  let url = "https://api.etherscan.io/api?module=block&action=getblocknobytime&timestamp=" + timestamp + "&closest=before";
  let result = await axios.get(url);
  let currentBlock = result.data.result;
  store.commit("SET_CURRENT_BLOCK", currentBlock);
  updateLastUpdate();
}

// async function getTotalInvestedETHFromDatabase() {
//   let totalInvestedETH = await axiosget("totalInvestedETH");
//   return parseFloat(totalInvestedETH);
// }

// async function getTopReferrersFromDatabase() {
//   let topReferrers = await axiosget("topReferrers");
//   topReferrers = JSON.parse(topReferrers);
//   return topReferrers;
// }

// async function getMultipleInvestmentsOnAllDaysFromDatabase() {
//   let investmentsOnAllDays = await axiosgetmultiple("investmentsOnAllDays");
//   return investmentsOnAllDays;
// }

async function axiosget(key) {
  let result = await axios.get(apiUrl + "/value/" + key);
  return result.data.value;
}

// async function axiosgetmultiple(key) {
//   let result = await axios.get(apiUrl + "/values/" + key);
//   return result.data;
// }

async function getETHPrice() {
  let currentETHPrice = await axiosget("currentETHPrice");
  store.commit("SET_CURRENT_ETH_PRICE", parseFloat(currentETHPrice));
  updateLastUpdate();
}

export function isValidAccountAsync(account) {
  if (infuraWeb3 === null) {
    createInfuraWeb();
  }
  if (infuraWeb3) {
    return infuraWeb3.utils.isAddress(account);
  } else {
    return false;
  }
}

export async function isValidAccount(account) {
  if (infuraWeb3 === null) {
    await createInfuraWeb();
  }
  if (infuraWeb3) {
    return infuraWeb3.utils.isAddress(account);
  } else {
    return false;
  }
}

export async function getBalance(address) {
  await createInfuraContract();
  let balance = await infuraWiseStakingContract.methods.balanceOf(address).call() / 10 ** 18;
  return balance;
}

export async function getStakes(address) {
  let stakeIds = [];
  let stakes = [];
  let contract = null;
  if (store.state.web3.connected) {
    await createContract();
    console.log("wiseStakingContract")
    contract = wiseStakingContract;
  } else {
    await createInfuraContract();
    console.log("infuraWiseStakingContract")
    contract = infuraWiseStakingContract;
  }
  try {
    stakeIds = await contract.methods.stakesPagination(address, 0, 0).call();
    let promises = [];
    for (let stakeId of stakeIds) {
      promises.push(contract.methods.checkStakeByID(address, stakeId).call({}, function(err, stake) {
        if (!err) {
          stakes.push({
            ...stake,
            'stakeId': stakeId
          });
        } else {
          stakes.push({
            ...stake,
            'stakeId': stakeId
          });
        }
      }));
    }
    await Promise.all(promises)
  } catch (ex) {
    console.log(ex.message)
    // return null;
  }
  return stakes;
}

// async function getAndStoreMultipleInvestmentsOnAllDays() {
//   let multipleInvestmentsOnAllDays = await getMultipleInvestmentsOnAllDaysFromDatabase();
//   let investmentsOnAllDays = JSON.parse(multipleInvestmentsOnAllDays[multipleInvestmentsOnAllDays.length - 1].value);
//   investmentsOnAllDays.shift(); //remove first element;
//   investmentsOnAllDays = investmentsOnAllDays.map(investment => investment * 1);
//   store.commit("SET_MULTIPLE_INVESTMENTS_ON_ALL_DAYS", multipleInvestmentsOnAllDays);
//   store.commit("SET_INVESTMENTS_ON_ALL_DAYS", investmentsOnAllDays);
//   updateLastUpdate();
// }

// async function getTotalUniswapTradingVolume() {
//   // https://thegraph.com/explorer/subgraph/uniswap/uniswap-v2
//   fetch('https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         query: `
//           query {
//             pairDayDatas(first: 1000, orderBy: date, orderDirection: asc,
//              where: {
//                pairAddress: "0x21b8065d10f73ee2e260e5b47d3344d3ced7596e",
//                date_gt: 1592505859
//              }
//             ) {
//             	id
//                date
//                dailyVolumeToken0
//                dailyVolumeToken1
//                dailyVolumeUSD
//                reserveUSD
//             }
//           }`
//       }),
//     })
//     .then(res => res.json())
//     .then(res => {
//       let uniswapTrading = {
//         totalVolumeUSD: -1,
//         totalFeesETH: -1,
//         totalFeesWISE: -1,
//       };
//       let totalVolumeUSD = 0;
//       let totalVolumeETH = 0;
//       let totalVolumeWISE = 0;
//       let feeFactor = 0.003;
//       let days = res.data.pairDayDatas;
//       for (let day of days) {
//         totalVolumeUSD += parseFloat(day.dailyVolumeUSD);
//         totalVolumeETH += parseFloat(day.dailyVolumeToken1);
//         totalVolumeWISE += parseFloat(day.dailyVolumeToken0);
//       }
//       uniswapTrading.totalVolumeUSD = totalVolumeUSD;
//       uniswapTrading.totalFeesETH = totalVolumeETH * feeFactor;
//       uniswapTrading.totalFeesWISE = totalVolumeWISE * feeFactor;
//       store.commit("SET_UNISWAP_TRADING", uniswapTrading);
//     });
// }

async function getPriceAndLiquidityAndRank() {
  // https://thegraph.com/explorer/subgraph/uniswap/uniswap-v2
  let pairId = "0x21b8065d10f73ee2e260e5b47d3344d3ced7596e" // WISE-ETH
  // let pairId = "0xd3d2e2692501a5c9ca623199d38826e513033a17" // UNI-ETH
  fetch('https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: `
          query {
             pairs(first: 20, orderBy: trackedReserveETH, orderDirection: desc) {
              id
              token0 {
                symbol
              }
              token1 {
                symbol
              }
              reserve0
              reserve1
              reserveUSD
              trackedReserveETH
              token0Price
              token1Price
              volumeUSD
            }
          }`
      }),
    })
    .then(res => res.json())
    .then(res => {
      let currentUniswapStats = {
        priceETH: -1,
        liquidityETH: -1,
        tokensWISE: -1,
        tokensETH: -1,
        volumeUSD: -1,
        rank: -1
      };
      let rank = 1;
      let pairs = res.data.pairs;
      for (let pair of pairs) {
        if (pair.id === pairId) {
          currentUniswapStats.priceETH = parseFloat(pair.token1Price);
          currentUniswapStats.liquidityETH = parseFloat(pair.trackedReserveETH);
          currentUniswapStats.tokensWISE = parseFloat(pair.reserve0);
          currentUniswapStats.tokensETH = parseFloat(pair.reserve1);
          currentUniswapStats.volumeUSD = parseFloat(pair.volumeUSD);
          currentUniswapStats.rank = rank;
          store.commit("SET_CURRENT_UNISWAP_STATS", currentUniswapStats);
          break;
        }
        rank++;
      }
    });
}

async function getAndStoreAllPenalties() {
  let penalties = await getAllPenaltiesFromDatabase();
  store.commit("SET_ALL_PENALTIES", penalties);
  updateLastUpdate();
}

async function getAllPenaltiesFromDatabase() {
  let penalties = await axiosget("allPenalties");
  let penaltiesArray = JSON.parse(penalties);
  return penaltiesArray;
}

async function getAndStoreStakeStats() {
  let stakeStats = await getStakeStatsFromDatabase();
  store.commit("SET_STAKESTATS", stakeStats);
  updateLastUpdate();
}

async function getStakeStatsFromDatabase() {
  let stakeStats = await axiosget("stakeStats");
  let stakeStatsObject = JSON.parse(stakeStats);
  return stakeStatsObject;
}


// import uniswapPrice from 'uniswap-price';
// async getUniswapPrice() {
//   let sourceToken = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"; // WETH
//   let sourceDecimal = 18;
//   // let destToken = "0x6B175474E89094C44Da98b954EedeAC495271d0F"; // DAI
//   // let destToken = "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984"; // UNI
//   let destToken = "0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6"; // WISE
//   let destDecimal = 18;
//   let network = 1;
//   let infurakey = "3b2691844ac84f1fb3e3f977da761c42";
//   let data = await uniswapPrice.getMidPrice(sourceToken, sourceDecimal, destToken, destDecimal, network, infurakey);
//   console.log(data);
//   this.currentPriceETH = parseFloat(data.quote2base);
//   this.currentPriceUSD = this.currentPriceETH * this.$store.state.currentETHPrice;
//   this.calculateResult();
// },

function updateLastUpdate() {
  let now = new Date();
  store.commit("SET_LAST_UPDATE", now);
  updateLastUpdateSeconds();
}

function updateLastUpdateSeconds() {
  let now = new Date();
  if (store.state.lastUpdate !== null) {
    let seconds = parseInt(
      (now.getTime() - store.state.lastUpdate.getTime()) / 1000
    );
    store.commit("SET_LAST_UPDATE_SECONDS", seconds);
  }
}
